import { createGetText, PageContent } from "../shared/utils/content.helper";

export interface FooterProps {
	content: PageContent;
}

export default function Footer({
    content
}: FooterProps) {
	const getText = createGetText(content);

    return (
		<footer className="footer">
			<div className="content">
				<p className="footer__copyright">© {new Date().getFullYear()} {getText("copyright")}</p>
				<div className="footer__nav">
					<a>Privacy</a>
					<a>Terms</a>
					<a>Contact</a>
				</div>
			</div>
		</footer>
    );
}